import { flatMap } from 'lodash';

import { CartSeat } from '../../classes/seat';
import { ItemType } from '../../classes/item-type';
import { ActionType, ActionTypes } from '../../actions/index';
import { ISeatMatchRequestModel } from '../../classes/request-model';
import { getCurrentLanguage } from '../../helpers/window-helpers';
import { setCartTimer } from './cart-actions';
import { request } from 'http';
import { SeatingOptionGroup } from '../../classes/seating-option';

export function postCheckoutCart(itemId: number, itemType: ItemType, cartItems: Array<CartSeat>,
    selectedAdditionalOptionGroups: Array<SeatingOptionGroup>, additionalNotes: string,
    language: string, proceedToAddons: boolean) {
    return (dispatch, state) => {
        postCheckout(itemId, itemType, cartItems, selectedAdditionalOptionGroups, additionalNotes, language, proceedToAddons).then((response: any) => {
            //dispatch(receiveReserveResult('Error fetching in cart seat style'));
            const result: IReserveResult = response as IReserveResult;

            if (result.success) {
                trackReserveValue(dispatch, result.reserveAmount);
                window.location.href = result.redirectUrl;
            } else {
                dispatch(receiveReserveResult(response));
            }
        });

    }
}

function trackReserveValue(dispatch, valueAmount: number) {
    dispatch({
        type: ActionTypes.TRACK_RESERVE_VALUE,
        value: valueAmount
    });
}

interface IReserveResult {
    success: boolean;
    message: string;
    redirectUrl: string;
    redirectButtonText: string;
    reserveAmount: number;
}

function postCheckout(itemId: number, itemType: ItemType, cartSeats: Array<CartSeat>, selectedAdditionalOptionGroups: Array<SeatingOptionGroup>,
    additionalNotes: string, language: string, proceedToAddons: boolean) {
    let cartSeatModel = cartSeats.map(seat => {
        return {
            ...{},
            selectedPricing: seat.selectedPricing,
            selectedSeatingOptions: flatMap(seat.selectedSeatingOptions),
            tessituraSeatNumber: seat.tessituraSeat.seatNumber,
            sectionName: seat.tessituraSeat.sectionDescription,
            seatRow: seat.tessituraSeat.rowText,
            seatNumber: seat.tessituraSeat.numberText,
            seatType: seat.tessituraSeat.seatType.toString(),
            confirmationText: seat.originalSeatStyleCulture.confirmPrompt
        };
    });
    return fetch(`${window.location.origin}/api/seating/ReserveSeats`,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                itemId: itemId,
                itemType: itemType,
                language: language,
                cartSeats: cartSeatModel,
                selectedSeatingOptions: selectedAdditionalOptionGroups, //used for non-seat bound requests
                addOnsRequested: proceedToAddons,
                additionalNotes: additionalNotes
            }),
            credentials: 'same-origin'
        })
        .then(response => {
            return response.json();
        })
        .catch(error => {
            console.error(error);
        });

}

function receiveReserveResult(result) {
    return {
        type: ActionTypes.RECEIVE_RESERVE_RESULT,
        value: result
    }
}

function receiveCheckQuickCheckoutResult(result) {
    return {
        type: ActionTypes.RECEIVE_QUICK_CHECKOUT_RESULT,
        value: result
    }
}

export function postCheckQuickCheckout(seatMatchRequest: ISeatMatchRequestModel) {
    return (dispatch, state) => {
        postCheckQuickCheckoutRequest(seatMatchRequest).then((response: any) => {

            const result: IReserveResult = response as IReserveResult;

            if (!result.success) {
                if (response.redirectUrl !== null && response.redirectUrl.length > 0) {
                    dispatch(receiveReserveResult(response));
                } else {
                    dispatch(receiveCheckQuickCheckoutResult(response));
                }
            } else {
                trackReserveValue(dispatch, result.reserveAmount);
                window.location.href = result.redirectUrl;
            }
        });
    }
}

export function postQuickCheckout(seatMatchRequest: ISeatMatchRequestModel) {
    return (dispatch, state) => {
        postQuickCheckoutRequest(seatMatchRequest).then((response: any) => {

            const result: IReserveResult = response as IReserveResult;

            if (result.success) {
                trackReserveValue(dispatch, result.reserveAmount);
                window.location.href = result.redirectUrl;
            } else {
                dispatch(receiveReserveResult(response));
            }
        });
    }
}

function createPostRequestWithSeatingFilters(url: string, requestModel: ISeatMatchRequestModel, shouldReserveSeats: boolean) {
    return fetch(url,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                filters: {
                    itemType: requestModel.itemType,
                    itemId: requestModel.itemId,
                    minPrice: requestModel.minPrice,
                    maxPrice: requestModel.maxPrice,
                    allowSeparatedSeats: requestModel.allowSeparatedSeats,
                    priceTypeQuantities: requestModel.requestedPriceTypes.filter(pt => { return pt.quantity > 0 }),
                    venueLevels: requestModel.selectedVenueLevels,
                    allowAisleAccessSelected: requestModel.allowAisleAccessSelected,
                    additionalSeatingOptions: requestModel.additionalSeatingOptions,
                    additionalNotes: encodeURI(requestModel.additionalNotes),
                    language: getCurrentLanguage()
                },
                confirmReserve: shouldReserveSeats
            }),
            credentials: 'same-origin'
        });
}

function postCheckQuickCheckoutRequest(requestModel: ISeatMatchRequestModel) {
    return createPostRequestWithSeatingFilters(`${window.location.origin}/api/seating/QuickCheckout`, requestModel, false)
        .then(response => {
            return response.json();
        })
        .catch(error => {
            console.error(error);
        });
}

function postQuickCheckoutRequest(requestModel: ISeatMatchRequestModel) {
    return createPostRequestWithSeatingFilters(`${window.location.origin}/api/seating/QuickCheckout`, requestModel, true)
        .then(response => {
            return response.json();
        })
        .catch(error => {
            console.error(error);
        });
}

function receiveQuickCheckoutResult(result) {
    return {
        type: ActionTypes.RECEIVE_RESERVE_RESULT,
        value: result
    }
}

export function getCartTimer() {
    return (dispatch, state) => {
        updateCartTimer().then((response: any) => {
            try {
                if (+response > 0) {
                    dispatch(setCartTimer(response));
                }
            } catch (ex) {

            }
        });
    }
}

function updateCartTimer() {
    return fetch(`${window.location.origin}/api/seating/GetCurrentCartTimer`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            credentials: 'same-origin'
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                return "ERROR";
            }
        })
        .catch(error => {
            console.error(error);
        });
}